import {
  Component,
  effect,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import {
  ESortOrder,
  TableSortOrder,
  ITableSortParams,
} from '../table.component';
import { TableCellComponent } from '../table-cell/table-cell.component';

@Component({
  selector: 'aw-table-header',
  templateUrl: './table-header.component.html',
  host: {
    '[class.bg-info-light]':
      'sortState === SortOrder.ASC || sortState === SortOrder.DESC',
    '[class.text-input-focus]':
      'sortState === SortOrder.ASC || sortState === SortOrder.DESC',
  },
})
export class TableHeaderComponent<T> extends TableCellComponent<T> {
  public readonly sortParams: InputSignal<ITableSortParams<T> | undefined> =
    input();
  public sortState: TableSortOrder = ESortOrder.ASC;
  public readonly onSort: OutputEmitterRef<ITableSortParams<T>> =
    output<ITableSortParams<T>>();
  protected readonly SortOrder: typeof ESortOrder = ESortOrder;

  constructor() {
    super();
    effect(() => {
      this.sortState = this.sortParams()?.order;
    });
  }

  public emitSort(): void {
    if (this.sortParams()) {
      this.sortState = this.determineSortState();
      this.onSort.emit({ ...this.sortParams()!, order: this.sortState });
    }
  }

  public resetParam(): void {
    this.sortState = undefined;
  }

  private determineSortState(): TableSortOrder {
    return this.sortState === ESortOrder.ASC
      ? ESortOrder.DESC
      : this.sortState === ESortOrder.DESC
        ? undefined
        : ESortOrder.ASC;
  }
}
